import { Radio, Input } from 'antd';
import { FC } from 'react';
import { FormButtons } from '../../../../../lib/components/Form/FormButtons';
import { FormContainer } from '../../../../../lib/components/Form/FormContainer';
import { FormField } from '../../../../../lib/components/Form/FormField';
import { FormState } from '../../../../../lib/hooks/useForm/types';
import { ClientConfigFormValues } from '../../hooks/useClientConfigForm';
import { BaseClientConfigForm } from './BaseClientConfigForm';

interface IProps {
	form_state: FormState<ClientConfigFormValues>;
	change_field_value: (field: keyof ClientConfigFormValues, value: any) => void;
	loading: boolean;
	on_submit: () => void;
}

export const AddClientConfigForm: FC<IProps> = ({ form_state, change_field_value, loading, on_submit }) => {
	return (
		<FormContainer {...{ disabled: false }}>
			<BaseClientConfigForm
				{...{
					is_updating: false,
					form_state,
					change_field_value,
				}}
			/>

			<FormField
				{...{
					label: 'Tipo de cliente',
					name: 'unlimited',
					form_state,
					required: true,
					children: (
						<Radio.Group
							{...{
								options: [
									{ label: 'Ilimitado', value: true },
									{ label: 'Restrito', value: false },
								],
								onChange: () => change_field_value('unlimited', !form_state.value.unlimited),
								value: form_state.value.unlimited,
								optionType: 'button',
								buttonStyle: 'solid',
							}}
						/>
					),
				}}
			/>
			<FormField
				{...{
					label: 'Cliente de Direito Autoral',
					name: 'copyright',
					form_state,
					required: true,
					children: (
						<Radio.Group
							{...{
								options: [
									{ label: 'Sim', value: true },
									{ label: 'Não', value: false },
								],
								onChange: () => change_field_value('copyright', !form_state.value.copyright),
								value: form_state.value.copyright,
								optionType: 'button',
								buttonStyle: 'solid',
							}}
						/>
					),
				}}
			/>

			<FormField
				{...{
					label: 'Pesquisa por CHAT',
					name: 'search_ai',
					form_state,
					required: true,
					children: (
						<Radio.Group
							{...{
								options: [
									{ label: 'Sim', value: true },
									{ label: 'Não', value: false },
								],
								onChange: () => change_field_value('search_ai', !form_state.value.search_ai),
								value: form_state.value.search_ai,
								optionType: 'button',
								buttonStyle: 'solid',
							}}
						/>
					),
				}}
			/>

			<FormField
				{...{
					label: 'Listar todo o conteúdo (não apenas o contratado)',
					name: 'allContentView',
					form_state,
					required: true,
					children: (
						<Radio.Group
							{...{
								options: [
									{ label: 'Sim', value: true },
									{ label: 'Não', value: false },
								],
								onChange: () =>
									change_field_value('allContentView', !form_state.value.allContentView),
								value: form_state.value.allContentView,
								optionType: 'button',
								buttonStyle: 'solid',
							}}
						/>
					),
				}}
			/>
			<FormField
				{...{
					label: 'Quantidade máxima de perguntas que o cliente pode realizar por mês na FÓRUM IAH',
					name: 'monthlyQuestionLimit',
					form_state,
					required: true,
					children: (
						<Input
							{...{
								type: 'number',
								value: form_state.value.monthlyQuestionLimit,
								onChange: (e) =>
									change_field_value('monthlyQuestionLimit', parseInt(e.target.value, 10) || 0),
							}}
						/>
					),
				}}
			/>

			<FormField
				{...{
					label: 'FÓRUM IAH disponível para todos os usuários que fizeram Login por Domínio?',
					name: 'enableDomainAccess',
					form_state,
					required: true,
					children: (
						<Radio.Group
							{...{
								options: [
									{ label: 'Sim', value: true },
									{ label: 'Não', value: false },
								],
								onChange: () =>
									change_field_value('enableDomainAccess', !form_state.value.enableDomainAccess),
								value: form_state.value.enableDomainAccess,
								optionType: 'button',
								buttonStyle: 'solid',
							}}
						/>
					),
				}}
			/>
			<FormField
				{...{
					label: 'Liberar anexos em chats na FÓRUM IAH',
					name: 'enableChatAttachments',
					form_state,
					required: true,
					children: (
						<Radio.Group
							{...{
								options: [
									{ label: 'Sim', value: true },
									{ label: 'Não', value: false },
								],
								onChange: () =>
									change_field_value('enableChatAttachments', !form_state.value.enableChatAttachments),
								value: form_state.value.enableChatAttachments,
								optionType: 'button',
								buttonStyle: 'solid',
							}}
						/>
					),
				}}
			/>
			<FormButtons
				{...{
					disabled: loading || !form_state.dirty,
					go_back_on_cancel: true,
					on_add_button_click: on_submit,
					on_update_button_click: undefined,
				}}
			/>
		</FormContainer>
	);
};
